import MenuSquares from './MenuSquares'

export default MenuSquares
